import { ChangeDetectionStrategy, Component } from '@angular/core';

import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'rt-icon-help',
  templateUrl: './icon-help.component.html',
  styleUrls: ['./icon-help.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
})
export class IconHelpComponent {}
